import { A11yModule } from '@angular/cdk/a11y';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowseChannelsDialogComponent } from './components/browse-channels-dialog/browse-channels-dialog.component';
import { PhotoCropDialogComponent } from './components/photo-crop-dialog/photo-crop-dialog.component';
import { ProfilePhotoComponent } from './components/profile-photo/profile-photo.component';
import { ChatWindowComponent } from './components/chat-window/chat-window.component';
import { ChatLauncherComponent } from './components/chat-launcher/chat-launcher.component';
import { NewChooserComponent } from './components/new-chooser/new-chooser.component';
import { NotifySettingsComponent } from './components/notify-settings/notify-settings.component';
import { ForwardPickerComponent } from './components/forward-picker/forward-picker.component';
import { ConversationListComponent } from './components/conversation-list/conversation-list.component';
import { ConversationMenuComponent } from './components/conversation-menu/conversation-menu.component';
import { ChatThreadComponent } from './components/chat-thread/chat-thread.component';
import { LongPressDirective } from '../shared/directives/long-press.directive';
import { SwipeActionsDirective } from '../shared/directives/swipe-actions.directive';
import { ConversationInfoDialogComponent } from './components/conversation-info-dialog/conversation-info-dialog.component';
import { NewConversationDialogComponent } from './components/new-conversation-dialog/new-conversation-dialog.component';

/**
 * In-house chat on the messaging hub (tasks/messaging-hub-architecture.md M1), as ONE floating window (like MedicAI
 * Connect's): `<app-chat-window>` is mounted once in the dashboard shell, and the header icon and sidenav item toggle
 * it through ChatUiService. No route of its own. Imported by SharedModule, which declares the dashboard.
 */
@NgModule({
  declarations: [ChatWindowComponent, ChatLauncherComponent, NewChooserComponent, NotifySettingsComponent, ForwardPickerComponent, ConversationListComponent, ConversationMenuComponent, ChatThreadComponent, NewConversationDialogComponent, BrowseChannelsDialogComponent, ConversationInfoDialogComponent, ProfilePhotoComponent, PhotoCropDialogComponent],
  imports: [
    CommonModule,
    LongPressDirective,
    SwipeActionsDirective,
    FormsModule,
    A11yModule,
    TextFieldModule,
    MatSlideToggleModule,
    MatBadgeModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatRadioModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatSelectModule,
  ],
  exports: [ChatWindowComponent, ChatLauncherComponent, ProfilePhotoComponent],
})
export class ChatModule {}
